import isomorphicCookie from 'isomorphic-cookie'
import {
  SET_ACCESS_TOKEN,
  SET_LAST_TOKEN,
  SET_TIME_OUT_NOTICE,
  SET_REDIRECT_AFTER_AUTH,
  SET_FIREBASE_MESSAGING_TOKEN,
  SET_AUTH_REQUEST_DATA,
  SET_LOGIN_STEP,
  SET_LOGIN_REQUESTID,
  SET_RECOVERY_STEP,
  SET_RECOVERY_REQUESTID,
} from './actions/types'

const authToken = isomorphicCookie.load('accessToken', {
  secure: process.env.NODE_ENV === 'production',
})
if (authToken && typeof window !== 'undefined' && window.localStorage) {
  localStorage.setItem('accessToken', true)
}

const lastAccessed = isomorphicCookie.load('lastAccessed', {
  secure: process.env.NODE_ENV === 'production',
})

const INITIAL_STATE = {
  accessToken: authToken || null,
  lastAccessed: lastAccessed || null,
  showTimeOutNotice: false,
  redirectAfterAuth: null,
  firebaseMessagingToken: null,
  authRequestData: null,
  loginStep: 0,
  loginRequestId: null,
  recoveryStep: 0,
  recoveryRequestId: null,
}

function setAccessToken(state, action) {
  const { accessToken } = action.payload

  if (!accessToken) {
    isomorphicCookie.remove('lastAccessed', {
      secure: process.env.NODE_ENV === 'production',
    })
  }

  return {
    ...state,
    accessToken,
  }
}

function setLastAccessed(state, action) {
  isomorphicCookie.save('lastAccessed', action.payload.lastAccessed, {
    secure: process.env.NODE_ENV === 'production',
  })

  return {
    ...state,
    lastAccessed: action.payload.lastAccessed,
  }
}

function setTimeOutNotice(state, action) {
  return {
    ...state,
    showTimeOutNotice: action.payload.showTimeOutNotice,
  }
}

function setRedirectAfterAuth(state, action) {
  return {
    ...state,
    redirectAfterAuth: action.payload.redirectAfterAuth,
  }
}

function setFirebaseMessagingToken(state, action) {
  return {
    ...state,
    firebaseMessagingToken: action.payload.firebaseMessagingToken,
  }
}

function setAuthRequestData(state, action) {
  return {
    ...state,
    authRequestData: action.payload.authRequestData,
  }
}

function setLoginStep(state, action) {
  return {
    ...state,
    loginStep: action.payload.loginStep,
  }
}

function setLoginRequestId(state, action) {
  return {
    ...state,
    loginRequestId: action.payload.loginRequestId,
  }
}

function setRecoveryStep(state, action) {
  return {
    ...state,
    recoveryStep: action.payload.recoveryStep,
  }
}

function setRecoveryRequestId(state, action) {
  return {
    ...state,
    recoveryRequestId: action.payload.recoveryRequestId,
  }
}

function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_ACCESS_TOKEN:
      return setAccessToken(state, action)
    case SET_LAST_TOKEN:
      return setLastAccessed(state, action)
    case SET_TIME_OUT_NOTICE:
      return setTimeOutNotice(state, action)
    case SET_REDIRECT_AFTER_AUTH:
      return setRedirectAfterAuth(state, action)
    case SET_FIREBASE_MESSAGING_TOKEN:
      return setFirebaseMessagingToken(state, action)
    case SET_AUTH_REQUEST_DATA:
      return setAuthRequestData(state, action)
    case SET_LOGIN_STEP:
      return setLoginStep(state, action)
    case SET_LOGIN_REQUESTID:
      return setLoginRequestId(state, action)
    case SET_RECOVERY_STEP:
      return setRecoveryStep(state, action)
    case SET_RECOVERY_REQUESTID:
      return setRecoveryRequestId(state, action)
    default:
      break
  }
  return state
}

export default reducer
